import { Divider } from 'enova-frontend-components';

import styled from '../../../../styled';

const LinkColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--ds-size-4);
  flex: 1;
`;

const FooterContent = styled.div`
  grid-area: content;
  display: flex;
  flex-direction: row;
  gap: var(--ds-size-18);
  flex-grow: 1;

  @media (max-width: 1280px) {
    flex-direction: column;
  }
`;

const StyledFooter = styled.footer`
  width: 100%;
  background: var(--ds-color-base-default);
  padding: var(--ds-size-12) var(--ds-size-10);
  color: var(--ds-color-base-contrast-default);

  a {
    color: var(--ds-color-base-contrast-subtle);
    display: flex;
    flex-direction: row;
    gap: var(--ds-size-2);
  }
`;

const CenteredContainer = styled.div`
  width: 100%;
  max-width: var(--max-width);
  margin: 0 auto;
  display: grid;
  gap: var(--ds-size-8);
  // Column width definition to ensure the logo takes up only as much space as it needs, while the content takes up the remaining space
  grid-template-columns: max-content minmax(0, 1fr);

  // Change the grid layout based on screen size
  grid-template-areas:
    'logo content'
    'divider divider'
    'copyright links';

  @media (max-width: 1280px) {
    grid-template-areas:
      'logo logo'
      'content content'
      'divider divider'
      'copyright links';
  }

  @media (max-width: 768px) {
    grid-template-areas:
      'logo'
      'content'
      'divider'
      'links'
      'copyright';

    grid-template-columns: 1fr;
  }
`;

const BottomLinksContainer = styled.div`
  display: flex;
  gap: var(--ds-size-4);
  grid-area: links;
  justify-content: flex-end;

  @media (max-width: 768px) {
    justify-content: flex-start;
  }
`;

const LogoContainer = styled.div`
  grid-area: logo;
  svg path {
    fill: var(--ds-color-base-contrast-default);
  }
`;

const LinkContainer = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: var(--ds-size-8);
  }
`;

const StyledDivider = styled(Divider)`
  grid-area: divider;
  width: 100%;
`;

const CopyrightContainer = styled.span`
  grid-area: copyright;
`;

export {
  StyledFooter,
  CenteredContainer,
  FooterContent,
  LinkColumn,
  BottomLinksContainer,
  LogoContainer,
  LinkContainer,
  StyledDivider,
  CopyrightContainer
};
